import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import PrimaryButton from "../designSystem/buttons/PrimaryButton";
import {ReactComponent as EmailIcon} from "../../assets/icons/email.svg";
import {ReactComponent as PhoneIcon} from "../../assets/icons/phone.svg";
import {ReactComponent as LinkedIcon} from "../../assets/icons/linkedin.svg";
import {ReactComponent as InstaIcon} from "../../assets/icons/instagram.svg";
import {ReactComponent as FacebookIcon} from "../../assets/icons/facebook.svg";

const ContactUsComponent = () => {
  const [form, setForm] = useState({
    name: "",
    number: "",
    email: "",
    message: "",
    consent: false,
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // clear field error as user types
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const next = {};

    if (!form.name.trim()) next.name = "Name is required";
    if (!form.number.trim()) next.number = "Number is required";
    if (!form.email.trim()) next.email = "Email is required";
    if (!form.message.trim()) next.message = "Message is required";
    if (!form.consent)
      next.consent = "Please confirm you have read the privacy policy";

    setErrors(next);
    return Object.keys(next).length === 0;
  };

  /**
   * Runs automatically on Google Form submit (installable trigger).
   * Sends the form response to your Node endpoint.
   */
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!validate()) return;

      const to = process.env.REACT_APP_ADVISER_EMAIL;

      const payload = {
        name: form.name.trim(),
        email: form.email.trim(),
        number: form.number.trim(),
        message: form.message.trim(),
        to: (to || "").trim(),
      };

      const url = `${process.env.REACT_APP_SERVER_URL}/send-adviser-contact-confirmation`;

      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errText = await res.text();
        console.log("API error:", errText);
        return;
      }

      // optional: success UI / reset
      setForm({
        name: "",
        number: "",
        email: "",
        message: "",
        consent: false,
      });

      setErrors({});
      console.log("Sent successfully");
    } catch (err) {
      console.log("handleSubmit error:", err);
    }
  };
  return (
    <div
      className="background-container  bottom-right-radius bg-gray-2 "
      id="contact-us"
    >
      <div className="content-container gap-xl ">
        <div className="content-semibold primary uppercase align-left ">
          contact US
        </div>
        <div className="row gap-xl grid2">
          <div className="column gap-xl align-left justify-center">
            <h2 className="text-primary-1">Ready to get started?</h2>
            <div className="content text-primary-1">
              If you'd like to discuss your mortgage or protection needs, we'd
              love to hear from you. Get in touch today for a friendly,
              no-obligation conversation and find out how we can help.
            </div>
            <div className="column gap-l">
              <div className="row-wrap gap-s align-center">
                <EmailIcon style={{ marginRight: 8 }} />

                <a
                  href="mail:support@duo-financial.com"
                  className="content text-primary-1"
                >
                  support@duo-financial.com
                </a>
              </div>
              <div className="row-wrap gap-s align-center">
                <PhoneIcon style={{ marginRight: 8 }} />
                <a href="tel:02477182004" className="content text-primary-1">
                  024 7718 2004
                </a>
              </div>
            </div>
            <div className="row-wrap gap-l">
              {/* <a href="https://www.linkedin.com/company/duo-financial/" target="_blank" rel="noopener noreferrer">
              <LinkedIcon style={{width: 24, height: 24}}/>
              </a> */}
              <a
                href="https://www.instagram.com/duo.financial"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstaIcon />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61590291127384"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon />
              </a>
            </div>
          </div>
          <form className="column gap-l align-left" onSubmit={handleSubmit}>
            <div className="row gap-l grid2">
              <div className="column gap-s">
                <div className="content text-primary-1">Full Name*</div>
                <input
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  className={errors.name ? "has-error body1" : "body1 text-primary-1"}
                />
                {errors.name && (
                  <span className="help-text text-error">{errors.name}</span>
                )}
              </div>

              <div className="column gap-s">
                <div className="content text-primary-1">Phone Number*</div>
                <input
                  name="number"
                  value={form.number}
                  onChange={handleChange}
                  className={errors.number ? "has-error body1" : "body1 text-primary-1"}
                />
                {errors.number && (
                  <span className="help-text text-error">{errors.number}</span>
                )}
              </div>
            </div>

            <div className="column gap-s">
              <div className="content text-primary-1">Email*</div>
              <input
                name="email"
                value={form.email}
                onChange={handleChange}
                className={errors.email ? "has-error body1" : "body1 text-primary-1"}
              />
              {errors.email && (
                <span className="help-text text-error">{errors.email}</span>
              )}
            </div>

            <div className="column gap-s">
              <div className="content text-primary-1">Message*</div>
              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                rows={8}
                className={errors.message ? "has-error body1" : "body1 text-primary-1"}
              />
              {errors.message && (
                <span className="help-text text-error">{errors.message}</span>
              )}
            </div>

            <div className="contact-consent">
              <input
                type="checkbox"
                name="consent"
                checked={form.consent}
                onChange={handleChange}
                id="consent"
              />
              <label htmlFor="consent" className="content text-primary-1">
                *I confirm I have read the{" "}
                <span
                  // href="/privacy-policy"
                  // target="_blank"
                  // rel="noopener noreferrer"
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                  onClick={() => navigate("/privacy-policy")}
                >
                  privacy policy
                </span>
              </label>
            </div>
            <PrimaryButton
              className="contact-submit"
              type="submit"
              text="Contact Us"
            />

            {/* <button className="contact-submit" type="submit">
            Submit
          </button> */}
            {errors.consent && (
              <span className="help-text text-error">{errors.consent}</span>
            )}
          </form>
          {/* <section className="contact-form-wrap">
        </section> */}
        </div>
      </div>
    </div>
  );
};

export default ContactUsComponent;
